import React from "react";
import '../styles/PlayerStats.css';

const PlayerStats = () => {
    return(
        <div id="playerStats">
            <h1>ApexDev</h1>
            <div id="playerStats__lines">
                <span id="player__lines__thick"></span>
                <span id="player__lines__thin"></span>
            </div>
            <h3>Elevate Your Online Presence</h3>
        </div>
    )
}

export default PlayerStats;